import { apiClient } from 'pobble-components/dist/api'

const apiGetMLInfo = token => apiClient.get(`/v3/magic_links/${token}`)

const apiResetML = id => apiClient.put(`/v3/magic_links/${id}/resend`)

const apiResendConfirmationEmail = id =>
  apiClient.put(`/v3/email_identities/${id}/resend_confirmation_email`)

export { apiGetMLInfo, apiResetML, apiResendConfirmationEmail }
